import { ConciergeCatalogRoute } from '@/lib/pages/concierge/ConciergeCatalogRoute';
import { getConciergeCatalogServerSideProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeYachtCatalogPage } from '@/lib/entities/concierge/server-content';

import { InferGetServerSidePropsType } from 'next';

const PATH = '/concierge/yacht';

export default function ConciergeYachtPage({
  page,
  locale,
  pageSeo,
  listingRobots,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <ConciergeCatalogRoute
      page={page}
      locale={locale}
      pageSeo={pageSeo}
      listingRobots={listingRobots}
      path={PATH}
      keywords="yacht charter phuket concierge"
      itemCatalog="yacht"
    />
  );
}

export const getServerSideProps = getConciergeCatalogServerSideProps(
  getConciergeYachtCatalogPage,
  PATH
);
